'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const formatMinutes = (timeInMin) => {
    const hours = Math.floor(timeInMin / 60);
    const mins = Math.round(timeInMin % 60);
    if (hours === 0)
        return `${mins}min`;
    if (mins === 0)
        return `${hours}h`;
    return `${hours}h${mins}min`;
};

exports.formatMinutes = formatMinutes;
//# sourceMappingURL=format-minutes.js.map
